 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		72: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		72: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"17":"BusinessProtect360.Generate","18":"CILeadForm","19":"CIP.FactFormApp","20":"CIProtect360.Dashboard","21":"CIProtect360.Details","22":"CIProtect360.Direct.Generate","23":"CIProtect360.Generate","24":"CampaignLeadForm","25":"CarProtect360","26":"CashCardShield","27":"CommissionStatement","28":"Common.Error","29":"ComplimentaryHomeContents","30":"ConsumerPortal","31":"ContactUs","32":"CorporateTravel","33":"Debug","34":"EMAPortal","35":"EarlyProtect360","36":"EarlyProtect360.Dashboard","37":"EarlyProtect360.Details","38":"FamilyProtect360","39":"FilipinoBond","40":"FlashPayShieldWithUpgrade","41":"HIProtect360Protect360","42":"HomeProtect360","43":"HomeProtectLite","44":"HomeSafe","45":"HomeStarterKit","46":"InternalDemoCookie","47":"KeymanProtect360","48":"KeymanProtect360.Dashboard","49":"KeymanProtect360.Details","50":"LeadForm","51":"LifePayment","52":"Loan Protect 360 Renewal","53":"MaidProtect360","54":"MotoringCardShieldWithUpgrade","55":"Motorshow2020","56":"PhoneProtect360","57":"PowerAgentPortal","58":"Prestige","59":"Prestige.Secured","60":"PublicHousingAssured","61":"ReviewUs","62":"SOA","63":"SingaporeTravelPass","64":"Touristcard","65":"TravelAssured","66":"TravelProtect360","67":"TravelProtect360Plus","68":"cileadform","69":"currencyconverter","71":"motorshow","73":"transferprotect360pro","74":"vCashCard","75":"weather"}[chunkId]||chunkId) + "." + {"0":"b348b15e","1":"82b1fedc","2":"fe058387","3":"067db21b","4":"3aa2f264","5":"a2f7ce98","6":"a63a0ed6","7":"ba00f8dc","8":"99191a61","9":"969693ca","10":"e1965544","11":"a1d03015","12":"e5bd96ee","13":"5a61e68d","14":"f9d66e12","15":"a67b2785","16":"b4129ae5","17":"16df89a8","18":"00116306","19":"3feee665","20":"d8b10b25","21":"d7356310","22":"f8f48ec0","23":"b94b2cd7","24":"afcbdddc","25":"1937743c","26":"d6f5e005","27":"10a1cc8d","28":"ea08edfd","29":"4403580b","30":"0fbb37d0","31":"af70ce55","32":"caf304bf","33":"0876eebd","34":"afa146f4","35":"d880d87f","36":"ed349edd","37":"cd25ed46","38":"7b6b97fc","39":"9214e144","40":"60389ca5","41":"09b6953d","42":"5a6b9dcb","43":"e314fe5c","44":"783feb07","45":"2b1b483d","46":"dd25946a","47":"39756881","48":"086c103d","49":"d9d110c2","50":"8b80f890","51":"39d27b76","52":"52350e31","53":"2de1e9cb","54":"a317e7bb","55":"0be83615","56":"28e7c7be","57":"7ca0e131","58":"85988adc","59":"c44c3f3d","60":"6453d804","61":"25182c0a","62":"f1596875","63":"69c985a7","64":"8ddce1e8","65":"1e8eda9b","66":"d557a0a8","67":"b004ca6b","68":"84bbce06","69":"a2a279fb","71":"39d6fa1e","73":"70926574","74":"b6bd95b6","75":"4c4fac03","77":"749a7c19","78":"2ce378b1","79":"b9d0c28b","80":"d5f8d96a","81":"3dfbdde9","82":"f5a5dc1b","83":"622430d4","84":"d958305b","85":"616681d4","86":"d7c7cbe9","87":"abefa9f0","88":"79e53a2d","89":"2e7b34fd","90":"b38255c9","91":"c699c06d","92":"ac1121dd","93":"3b80a974","94":"aa91a06a","95":"a9233ed0","96":"ca20fe77","97":"c713c3e8","98":"dd8bbb84","99":"3f897a4e","100":"d74f3081","101":"ba9b93cf","102":"fd1043e5","103":"0d02c02e","104":"9375b6be","105":"e330e10d","106":"2c0ea43a","107":"b5ef8fa8","108":"d85faccc","109":"3af09348","110":"8e023b55","111":"049cec85","112":"95c713e3","113":"f0ed0eaf","114":"f6ac3bce","115":"3c1913c9","116":"417e9073","117":"d672f3ef","118":"bdc7dcb7","119":"5594b873","120":"b36f59fb","121":"bd837f5a","122":"92dba979","123":"a88ff6d4","124":"488d526e","125":"902ad410","126":"0308ca9b","127":"6dd3f434","128":"c602607a","129":"f5708a15","130":"2dbe823b","131":"ce8b0592","132":"086faac7","133":"1d77cc41","134":"6f6f818f","135":"a204cfff","136":"763e595e","137":"daaf5e7f","138":"d26f184b","139":"0c69f22b","140":"113dab6a","141":"152045c7","142":"b9304302","143":"7c22abc4","144":"27356254"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"17":1,"19":1,"22":1,"24":1,"25":1,"26":1,"27":1,"29":1,"30":1,"32":1,"33":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1,"45":1,"47":1,"50":1,"51":1,"53":1,"54":1,"56":1,"57":1,"58":1,"59":1,"60":1,"62":1,"63":1,"64":1,"65":1,"66":1,"67":1,"68":1,"69":1,"71":1,"73":1,"74":1,"75":1,"78":1,"79":1,"80":1,"81":1,"82":1,"83":1,"90":1,"92":1,"98":1,"100":1,"103":1,"106":1,"107":1,"108":1,"109":1,"110":1,"111":1,"112":1,"123":1,"124":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"17":"BusinessProtect360.Generate","18":"CILeadForm","19":"CIP.FactFormApp","20":"CIProtect360.Dashboard","21":"CIProtect360.Details","22":"CIProtect360.Direct.Generate","23":"CIProtect360.Generate","24":"CampaignLeadForm","25":"CarProtect360","26":"CashCardShield","27":"CommissionStatement","28":"Common.Error","29":"ComplimentaryHomeContents","30":"ConsumerPortal","31":"ContactUs","32":"CorporateTravel","33":"Debug","34":"EMAPortal","35":"EarlyProtect360","36":"EarlyProtect360.Dashboard","37":"EarlyProtect360.Details","38":"FamilyProtect360","39":"FilipinoBond","40":"FlashPayShieldWithUpgrade","41":"HIProtect360Protect360","42":"HomeProtect360","43":"HomeProtectLite","44":"HomeSafe","45":"HomeStarterKit","46":"InternalDemoCookie","47":"KeymanProtect360","48":"KeymanProtect360.Dashboard","49":"KeymanProtect360.Details","50":"LeadForm","51":"LifePayment","52":"Loan Protect 360 Renewal","53":"MaidProtect360","54":"MotoringCardShieldWithUpgrade","55":"Motorshow2020","56":"PhoneProtect360","57":"PowerAgentPortal","58":"Prestige","59":"Prestige.Secured","60":"PublicHousingAssured","61":"ReviewUs","62":"SOA","63":"SingaporeTravelPass","64":"Touristcard","65":"TravelAssured","66":"TravelProtect360","67":"TravelProtect360Plus","68":"cileadform","69":"currencyconverter","71":"motorshow","73":"transferprotect360pro","74":"vCashCard","75":"weather"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0","1":"31d6cfe0","2":"31d6cfe0","3":"31d6cfe0","4":"31d6cfe0","5":"31d6cfe0","6":"31d6cfe0","7":"31d6cfe0","8":"31d6cfe0","9":"31d6cfe0","10":"31d6cfe0","11":"31d6cfe0","12":"31d6cfe0","13":"31d6cfe0","14":"31d6cfe0","15":"31d6cfe0","16":"31d6cfe0","17":"98bb9c2a","18":"31d6cfe0","19":"d33f62d9","20":"31d6cfe0","21":"31d6cfe0","22":"58058363","23":"31d6cfe0","24":"05f863ac","25":"ddf1f108","26":"04bc7233","27":"d33f62d9","28":"31d6cfe0","29":"0e4fba13","30":"cd194874","31":"31d6cfe0","32":"ac3f861f","33":"5d27deaa","34":"31d6cfe0","35":"31d6cfe0","36":"31d6cfe0","37":"31d6cfe0","38":"ddf1f108","39":"ddf1f108","40":"0e4fba13","41":"ddf1f108","42":"471a3a57","43":"471a3a57","44":"471a3a57","45":"0e4fba13","46":"31d6cfe0","47":"58058363","48":"31d6cfe0","49":"31d6cfe0","50":"dd9a60e3","51":"a858c2f5","52":"31d6cfe0","53":"33f2167c","54":"0e4fba13","55":"31d6cfe0","56":"471a3a57","57":"716aad65","58":"2fc531d7","59":"5f5d4f62","60":"471a3a57","61":"31d6cfe0","62":"d33f62d9","63":"2e8fdc12","64":"344cc04e","65":"86c9f98d","66":"2e8fdc12","67":"86c9f98d","68":"22b92479","69":"7b4f34de","71":"49234f01","73":"33f2167c","74":"94b03ce8","75":"23255cb6","77":"31d6cfe0","78":"cce35a68","79":"2d576837","80":"de3d9b53","81":"8b4bb37c","82":"f93319e8","83":"f93319e8","84":"31d6cfe0","85":"31d6cfe0","86":"31d6cfe0","87":"31d6cfe0","88":"31d6cfe0","89":"31d6cfe0","90":"6daa0d5f","91":"31d6cfe0","92":"6daa0d5f","93":"31d6cfe0","94":"31d6cfe0","95":"31d6cfe0","96":"31d6cfe0","97":"31d6cfe0","98":"6daa0d5f","99":"31d6cfe0","100":"6daa0d5f","101":"31d6cfe0","102":"31d6cfe0","103":"4b48318c","104":"31d6cfe0","105":"31d6cfe0","106":"4b48318c","107":"4b48318c","108":"4b48318c","109":"4b48318c","110":"4b48318c","111":"4b48318c","112":"4b48318c","113":"31d6cfe0","114":"31d6cfe0","115":"31d6cfe0","116":"31d6cfe0","117":"31d6cfe0","118":"31d6cfe0","119":"31d6cfe0","120":"31d6cfe0","121":"31d6cfe0","122":"31d6cfe0","123":"5fe6802c","124":"5fe6802c","125":"31d6cfe0","126":"31d6cfe0","127":"31d6cfe0","128":"31d6cfe0","129":"31d6cfe0","130":"31d6cfe0","131":"31d6cfe0","132":"31d6cfe0","133":"31d6cfe0","134":"31d6cfe0","135":"31d6cfe0","136":"31d6cfe0","137":"31d6cfe0","138":"31d6cfe0","139":"31d6cfe0","140":"31d6cfe0","141":"31d6cfe0","142":"31d6cfe0","143":"31d6cfe0","144":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.hlas.com.sg/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonphlas-react-app"] = this["webpackJsonphlas-react-app"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
